<button *ngIf="isDisplay()"
        (click)="openHelpContent()">
    {{ 'generic.help.modal_page' | translate }}
</button>